import { Avatar, Col, Row } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useGetIcon } from "../../hooks/useGetIcon";
import { PaymentDetailsProps } from "./PaymentDetails";
import { PAYEE_TYPES } from "../../../../../lib/constants";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";
import { useCallback, useState } from "react";
import { DisbursementModal } from "./DisbursementModal";
import { ClockCircleOutlined } from "@ant-design/icons";

const getDisbursementKey = (item: any, index: number) =>
  [item.type, item.method, item.payeeName, item.amount, item.date, index]
    .filter(Boolean)
    .join("-");

export const DisbursementsList = ({
  paymentRecord,
  accountRoleInfo,
}: PaymentDetailsProps) => {
  const { getIcon } = useGetIcon();

  const [open, setOpen] = useState<boolean>(false);
  const [selectedDisbursement, setSelectedDisbursement] = useState<any>(null);

  const openModal = useCallback((item: any) => {
    setSelectedDisbursement(item);
    setOpen(true);
  }, []);

  return (
    <>
      <Row>
        {paymentRecord.disbursements.length > 0 && (
          <>
            <Row className="w-100 mb-3">
              <p className="h h5">Disbursements</p>
            </Row>
            {paymentRecord.onHold && (
              <Row className="disclamer align-start">
                <ClockCircleOutlined className="warning mr-2 disclamer-icon" />
                <div className="disclamer-body">
                  <p className="mt-0 mb-2 text-sm title">
                    Any payment received over $5,000.00 in the form of a
                    personal check will be held for a period of 5-7 business
                    days before they are released
                  </p>
                </div>
              </Row>
            )}
            {paymentRecord.disbursements.map((item: any, index: number) => (
              <Row
                key={getDisbursementKey(item, index)}
                className="align-center w-100 justify-space-between item-container"
                onClick={() => openModal(item)}
              >
                <Col span={4}>
                  <Row className="align-center avatar">
                    <Avatar
                      icon={getIcon("Disbursement")}
                      size={40}
                      className="option d-flex justify-center"
                    />
                  </Row>
                </Col>
                <Col span={12}>
                  <Row className="d-block h-100 align-content-center item-title">
                    <p className="my-0 text-md w-500 elipsis">
                      {item.payeeName}
                    </p>
                    <p className="my-0 text-md title">
                      {PAYEE_TYPES.find((type) => type.value === item.type)
                        ?.label ?? "Other"}
                    </p>
                  </Row>
                </Col>
                <Col span={6} className="align-self-start">
                  <Row className="h-100 justify-end item-amount flex-nowrap">
                    <p className="my-0 text-md w-500 text-no-wrap">
                      {getFormattedCurrency(item.amount)}
                    </p>
                  </Row>
                </Col>
                <Col span={1} className="align-self-start">
                  <Row className="justify-end pt-1">
                    <RightOutlined className="text-sm title" />
                  </Row>
                </Col>
              </Row>
            ))}
          </>
        )}
        {selectedDisbursement && (
          <DisbursementModal
            disbursementRecord={selectedDisbursement}
            accountRoleInfo={accountRoleInfo}
            open={open}
            setOpen={setOpen}
          />
        )}
      </Row>
    </>
  );
};
